/**
 * 会社名のクライアント検証ヘルパー（admin / hostess 共通）。
 *
 * 仕様: docs/database/20260619-bizcard-company-edit-target-spec.md（P3 / G3）
 * 「trim 後 最小1文字以上 ＋ 記号のみ拒否 ＋ 最大 200 文字」。会社マスタ編集
 * （company-form-modal）の name と上限を一致させる。
 *
 * 記号のみ（「！！！」「---」等）の拒否はクライアントが担当する。サーバの
 * normalize_company_name は記号を除去しないため正規化しても空にならず、
 * クライアントでしか弾けない。一方「株式会社」単体のような法人格のみ
 * （normalize 後に空）はサーバ RPC 側が明示エラーにする（2層で漏れなく弾く）。
 */

/** 会社名の最大文字数（会社マスタ編集 company-form-modal の name と一致） */
export const COMPANY_NAME_MAX_LENGTH = 200;

/**
 * 会社名に「意味のある文字」が最低1つ含まれるか。
 * 文字（あらゆる言語のレター）または数字を 1 つ以上含めば true。
 * 空白・記号のみ（trim 後に空、または記号だけ）は false。
 *
 * \p{L} は漢字・かな・全角英字など全言語のレター、\p{N} は半角/全角の数字を含む。
 */
export function companyNameHasContent(value: string | null | undefined): boolean {
  if (!value) return false;
  if (value.trim().length === 0) return false;
  return /[\p{L}\p{N}]/u.test(value);
}
